import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { HeaderComponent } from 'src/app/shared/header/header.component';
import { FooterComponent } from 'src/app/shared/footer/footer.component';

@Component({
  selector: 'app-master-page',
  templateUrl: './master-page.component.html',
  styleUrls: ['./master-page.component.css'],
  standalone: true,
  imports: [CommonModule, RouterModule, HeaderComponent, FooterComponent]
})

export class MasterPageComponent implements OnInit {

  addclass: string = '';
  buttonShow: boolean = false;
  TopbarShow: boolean = false;
  footerClass: string = '';
  developerPage: boolean = false;
  hideFooter: boolean = false;
  shopPages: boolean = false;

  constructor(private cdr: ChangeDetectorRef) { }

  ngOnInit(): void {
  }

  /**
   * Router activation
   */
  onActivate(componentReference: any) {
    setTimeout(() => {
      this.addclass = componentReference.navClass;
      this.buttonShow = componentReference.buttonList;
      this.TopbarShow = componentReference.sliderTopbar;
      this.footerClass = componentReference.footerVariant;
      this.developerPage = componentReference.isdeveloper;
      this.hideFooter = componentReference.hideFooter;
      this.shopPages = componentReference.shopPages;
    }, 0);
  }
}
